module.exports = __webpack_public_path__ + "img/pcBanner23.37467c91.png";